import { formatPattern } from "react-router-utils";
import ImmutablePropTypes from "react-immutable-proptypes";
import ProductList from "app/components/ProductList";
import PropTypes from "prop-types";
import React from "react";
import Title from "app/components/UI/Title";
import classes from "./ShopPage.module.css";

export const ShopPage = ({ club, clubId, translate, products, isLoading, history }) => {
  if (club && false === club.get("eshop")) {
    history.push(formatPattern("/club-not-found"));
  }

  return (
    <div className={classes.pageContainer}>
      <Title component="h2">{translate("Le practice")}</Title>

      <ProductList clubId={clubId} products={products} isLoading={isLoading} />
    </div>
  );
};

ShopPage.propTypes = {
  translate: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  products: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired
};

export default ShopPage;



// WEBPACK FOOTER //
// ./src/app/components/ShopPage/ShopPage.js